import React from "react";
import "./SkeletonStyle/SkeletonStyle.css";

export const GoalListingSkeleton = () => {
  const skeletonItems = Array.from({ length: 5 }); // total number of goal cards

  return (
    <div style={{ padding: "1rem" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(1, 1fr)",
          gap: "1rem",
        }}
      >
        {skeletonItems.map((_, index) => (
         <div key={index} style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
         <div className="skeleton" style={{ width: "30%", height: "280px" }}></div>
          <div className="skeleton" style={{ width: "70%", height: "280px" }}></div>
        </div>
        ))}
      </div>
    </div>
  );
};
